import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import DOMPurify from 'dompurify';
import Header from '../components/Header';
import Footer from '../components/Footer';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const DynamicPage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${API_URL}/api/pages/${slug}`);
        
        if (!response.ok) {
          if (response.status === 404) {
            setError('Sayfa bulunamadı');
          } else {
            setError('Bir hata oluştu');
          }
          return;
        }

        const data = await response.json();
        setPage(data);
      } catch (err) {
        console.error('Sayfa yükleme hatası:', err);
        setError('Sayfa yüklenirken bir hata oluştu');
      } finally {
        setLoading(false);
      }
    };

    fetchPage();
  }, [slug]);

  if (loading) {
    return (
      <>
        <Header />
        <div className="min-h-screen flex items-center justify-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600"></div>
        </div>
        <Footer />
      </>
    );
  }

  if (error || !page) {
    return (
      <>
        <Header />
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <h1 className="text-6xl font-bold text-gray-300 mb-4">404</h1>
            <h2 className="text-2xl font-semibold text-gray-700 mb-4">
              {error || 'Sayfa Bulunamadı'}
            </h2>
            <p className="text-gray-500 mb-6">
              Aradığınız sayfa mevcut değil veya kaldırılmış olabilir.
            </p>
            <button
              onClick={() => navigate('/')}
              className="bg-red-600 text-white px-6 py-3 rounded-lg hover:bg-red-700 transition-colors"
            >
              Ana Sayfaya Dön
            </button>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />
      <div className="min-h-screen bg-gray-50">
        {/* Page Header */}
        <div className="bg-white border-b">
          <div className="container mx-auto px-4 py-8">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-800">
              {page.title}
            </h1>
            {page.meta_description && (
              <p className="text-gray-600 mt-2">
                {page.meta_description}
              </p>
            )}
          </div>
        </div>

        {/* Page Content */}
        <div className="container mx-auto px-4 py-12">
          <div className="bg-white rounded-lg shadow-md p-6 md:p-8 lg:p-12">
            <div 
              className="prose prose-lg max-w-none
                prose-headings:text-gray-800 
                prose-p:text-gray-700 prose-p:leading-relaxed
                prose-a:text-red-600 prose-a:no-underline hover:prose-a:underline
                prose-strong:text-gray-800
                prose-ul:text-gray-700 prose-ol:text-gray-700
                prose-img:rounded-lg prose-img:shadow-md"
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(page.content || '') }}
            />
          </div>

          {/* Back button */}
          <div className="mt-8 text-center">
            <button
              onClick={() => navigate(-1)}
              className="text-red-600 hover:text-red-700 font-semibold"
            >
              ← Geri Dön
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default DynamicPage;
